import React from 'react';

const Sidebar = () => {
    return (
        <div className="w-[360px] h-screen bg-custom_BG-200 fixed left-0 top-0 border-r border-custom_stroke-100 rounded-r-xl px-8 py-10 flex flex-col">
            {/* Logo */}
            <div className="mb-6">
                <img src="./logo.svg" alt="Logo" className="h-18" />
            </div>

            {/* Description Section */}
            <div className="mb-8 border-b border-custom_stroke-200 pb-8 border-b-[0.5px]">
                <p className="text-base leading-8 text-custom_text-100 font-Zilla">
                    Nudges are contextual hints designed to encourage users to take actions or make decisions they might not naturally choose. They can also introduce new features or functions in a way that feels natural and timely.
                </p>
            </div>

            {/* Short Description and Button Section */}
            <div className="mb-8 border-b border-custom_stroke-200 pb-8 border-b-[0.5px]">
                <p className="mb-4 text-base leading-8 text-custom_text-100 font-Zilla">
                    This collection provides examples of nudges from various apps for inspiration.
                </p>
                <a 
                href="https://forms.gle/TFPTTMmFabuoHAAcA" // Replace with the actual URL
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-flex items-center bg-custom_accent-100 text-gray-900 px-4 py-3 text-base font-medium font-Zilla rounded-md border border-neutral-950 hover:bg-custom_accent-100/90 hover:shadow-[inset_0_0_0_1px_#000000] transition-all duration-200"
                >
                    Submit a Nudge
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                 </a>
            </div>

            {/* Title and Badge Section */}
            <div>
                <h3 className="text-xs font-Zilla text-custom_text-100 mb-2">CURATED BY</h3>
                <a 
                href="https://www.tonyzeb.design/"
                target="_blank"
                rel="noreferrer" 
                className="inline-flex items-center space-x-2 rounded-full border border-custom_stroke-200 hover:shadow-[inset_0_0_0_0.5px_#000000] transition-colors hover:bg-white">
                    <img 
                        src="./profile_pic.jpg" 
                        alt="User Avatar" 
                        className="w-8 h-8 rounded-full object-cover ml-1 my-1"
                    />
                    <span className="font-Zilla text-base text-custom_text-100 pr-2">Tony Sebastian</span>
                </a>
            </div>
        </div>
    );
};

export default Sidebar;